module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/access-denied/access-denied.component.css
// module id = ./src/app/components/error/access-denied/access-denied.component.css
// module chunks = main